import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AutomationVersionReviewSummary } from '@/types/automations.ts';
import { create_automation_version_comparison_v3_summary_url } from '@/utils/urls.ts';

type GenerateVersionReviewSummaryParams = {
  targetVersionId: string;
  baseVersionId: string;
  expectedTargetFingerprint: string;
};

export default function useGenerateVersionReviewSummary() {
  const apiClient = useApiClient();
  return useMutation<
    AutomationVersionReviewSummary,
    AxiosError<{ code?: string }>,
    GenerateVersionReviewSummaryParams
  >({
    retry: false,
    mutationFn: async ({ targetVersionId, baseVersionId, expectedTargetFingerprint }) => (
      await apiClient.post(
        create_automation_version_comparison_v3_summary_url(targetVersionId),
        {
          base_version_id: baseVersionId,
          expected_target_fingerprint: expectedTargetFingerprint,
        },
      )
    ).data,
  });
}
